import { RatingBadge } from "./RatingBadge";

export function LegendDetails({ legend }) {
  if (!legend) return null;

  return (
    <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
      <div
        className="flex items-center justify-between mb-2"
      >
        <h4 className="font-medium text-gray-600 text-lg my-2 rounded">{legend.description}</h4>
      </div>


      <div className="mb-3">
        <h5 className="text-sm font-medium text-gray-700 mb-2">Rating Definitions:</h5>
        {legend.performanceRatingDefinitions && legend.performanceRatingDefinitions.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2">
            {legend.performanceRatingDefinitions
              .sort((a, b) => a.rating - b.rating)
              .map((def) => (
                <div
                  key={def.id}
                  className={`p-4 rounded-lg border border-gray-200 bg-white hover:border-blue-300 transition-colors shadow-sm`}
                >
                  <div className="flex items-start mb-3">
                    <RatingBadge rating={def.rating} />
                    <div className="ml-3">
                      <div className="font-medium text-gray-800">{def.code || `Rating ${def.rating}`}</div>
                      <div className="text-xs text-gray-500 mt-1">{def.description}</div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        ) : (
          <div className="text-center py-6 text-gray-500 bg-gray-100 rounded-lg">
            No rating definitions available for this legend group
          </div>
        )}
      </div>
    </div>
  );
}
